import {
  SET_USER,
  SET_ERRORS,
  CLEAR_ERRORS,
  LOADING_UI,
  SET_UNAUTHENTICATED,
  LOGIN_MAIL,
  USE_TRUE,
  USE_FALSE,
  USER_FILTER_DATA,
  LOGIN_LOADER,
  LOGIN_LOADER_OFF,
} from '../type';
import axios from 'axios';
import { toast } from 'react-toastify';
import { login } from '../../Component/Helpers/api';
import { loginMail } from '../../Component/Helpers/api';
import constant from '../../constant';
import { useEffect } from 'react';

export const LoginMail = (params, history) => dispatch => {
  let authToken = JSON.parse(localStorage.getItem('headData'))
  dispatch({ type: LOADING_UI });
  axios
    .post(loginMail.email, params, {
      headers: {
        Authorization: authToken?.spintlyToken,
      }
    })
    .then(res => {
      if (res.data.data.status === 200) {
        dispatch({ type: LOGIN_MAIL, payload: res.data.data });
        dispatch({ type: USE_TRUE });
        dispatch({ type: LOGIN_LOADER_OFF });
        dispatch({ type: CLEAR_ERRORS });
        // toast.configure();
        // toast.success(res.data.message, {
 
        // });
      } else {
        toast.configure();
        dispatch({ type: USE_FALSE });
        dispatch({ type: LOGIN_LOADER_OFF });
        toast.error(res.data.data.status_message, {

        });
        dispatch({ type: CLEAR_ERRORS });
      }
    })
    .catch(error => {
      dispatch({ type: CLEAR_ERRORS });
    });
};

export const setLoginLoader = () => dispatch => {
  dispatch({ type: LOGIN_LOADER });
};

export const loginUser = (params, history) => dispatch => {
  let authToken = JSON.parse(localStorage.getItem('headData'))
  dispatch({ type: LOADING_UI });
  axios
    .post(login.login, params, {
      headers: {
        Authorization: authToken?.spintlyToken,
      }
    })
    .then(res => {
      if (res.data.status === 200) {
        //const token = res.data.data.token;
        const token = '763B744878E1736938EB78CB92179';
        const headData = res.data.data.data;
        headData.spintlyToken = res.data.data.spintlyToken;
        setAuthorizationHeader(token, headData);
        localStorage.setItem('bannerStatus', "Yes")
        //dispatch(getUserData());
        history.push('/Dashboard');
        //redirection of landing page for corporate gifting temporary 
        // history.push('/landing-page');
        window.location.reload();
        // toast.configure();
        // toast.success(res.data.message, {
    
        // });
        dispatch({ type: USER_FILTER_DATA, payload: res.data.data });
      } else if (res.data.status == 400) {
        toast.configure();
        toast.error(res.data.status_message, {
    
        });
        dispatch({ type: CLEAR_ERRORS });
      } else {
        toast.configure();
        toast.error(res.data.status_message, {

        });
        dispatch({ type: CLEAR_ERRORS });
      }
    })
    .catch(error => {
      dispatch({ type: CLEAR_ERRORS });
    });
};








//oldcode

// export const locationUser = params => {
//   axios

//     .get(
//       `${process.env.REACT_APP_API_URL}basic-data/get-location-by-spoc`,
//       params,
//     )

//     .then(resp => {
//       if (resp.status === 200) {

//         let locIdArr = [];

//         let locArr = [];
//         let zohoarr = [];

//         resp.data.data.map(item => {
//           locIdArr.push(item.rec_id);
//         });

//         resp.data.data.map(item =>
//           locArr.push({ label: item.location_name, value: item.rec_id }),
//         );

//         resp.data.data.map(item =>
//           zohoarr.push({ label: item.location_name_zoho, value: item.rec_id }),
//         );

//         localStorage.setItem('locationData', JSON.stringify(locIdArr));

//         localStorage.setItem('spocLocationDetails', JSON.stringify(locArr));
//         localStorage.setItem(
//           'spocLocationDetailsZoho',
//           JSON.stringify(zohoarr),
//         );

//         // dispatch({ type: USER_LOCATION_DATA, payload: resp.data.data });
//       }
//     });
// };


export const locationUser = async params => {
  let authToken = JSON.parse(localStorage.getItem('headData'))
  const resp = await axios
    .get(
      `${process.env.REACT_APP_API_URL}basic-data/get-location-by-spoc`,
      params, {
      headers: {
        Authorization: authToken?.spintlyToken,
      }
    }
    )
  if (resp.status === 200) {



    let locIdArr = [];
    let locArr = [];
    let zohoarr = [];
    resp.data.data.map(item => {
      locIdArr.push(item.rec_id);
    });
    resp.data.data.map(item => locArr.push({ label: item.location_name, value: item.rec_id }),
    );
    resp.data.data.map(item => zohoarr.push({ label: item.location_name_zoho, value: item.rec_id }),
    );
    localStorage.setItem('locationData', JSON.stringify(locIdArr));
    localStorage.setItem('spocLocationDetails', JSON.stringify(locArr));
    localStorage.setItem(
      'spocLocationDetailsZoho',
      JSON.stringify(zohoarr),
    );
  }

  axios
    .get(
      `${process.env.REACT_APP_API_URL}basic-data/get-all-locations`, {
      headers: {
        Authorization: authToken?.spintlyToken,
      }
    }
    )
    .then(res => {
      if (res.data.status == "success") {
        localStorage.setItem('allLocationWithShortName', JSON.stringify(res.data.data));
      }
    });
};






export const setAuthorizationHeader = (token, headData) => {
  const getToken = `Bearer ${token}`;

  localStorage.setItem('token', getToken);
  localStorage.setItem('headData', JSON.stringify(headData));
  axios.defaults.headers.common['Authorization'] = getToken;
};

// export const getUserData = () => (dispatch) => {
//     dispatch({ type: LOADING_UI })
//     axios.get(login.login)
//         .then(res => {
//             dispatch({
//                 type: SET_USER,
//                 payload: res.data.data
//             })
//         }).catch(error => {
//             dispatch({
//                 type: SET_ERRORS,
//                 payload: []
//             })
//         });
// }

export const setAMSToken = async companyId => {
  const url = `${constant.AMS_URL}admin/v1/api/create-jwt-token`;
  const param = {
    bussinessId: '',
    clientId: companyId.toString(),
  };

  await axios
    .post(url, param)
    .then(res => {
      localStorage.setItem('amsToken', JSON.stringify(res.data.data.attToken));
    })
    .catch(error => {

    });
};

export const getServiceAccess = async companyId => {
  try {
    let authToken = JSON.parse(localStorage.getItem('headData'))
    const url = `${process.env.REACT_APP_API_URL}userRoles/get-service-access`;
    const params = {
      company_id: companyId,
    };
    const response = await axios.post(url, params, {
      headers: {
        Authorization: authToken?.spintlyToken,
      }
    });
    if (response.data.status == 200) {
      return response.data.data.accessServices;
    } else {
      return [];
    }
  } catch (error) {
    return [];
  }
};
